export const lifecycleStates = [
  'draft',
  'dirty',
  'ready',
  'published',
] as const;

export type LifecycleState = (typeof lifecycleStates)[number];

export const lifecycleLabels: Record<LifecycleState, string> = {
  draft: 'Draft',
  dirty: 'Dirty',
  ready: 'Ready',
  published: 'Published',
};

export function isLifecycleState(value: string): value is LifecycleState {
  return (lifecycleStates as readonly string[]).includes(value);
}
